<template>
  <div class="task-new-filter--cloud" v-if="!loading">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: [ 'loading'],
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.task-new-filter--cloud {
  display: flex;
  align-items: center;
  .fadeDown-enter-active {
    animation: fadeInUpBig 1s;
  }
  .fadeDown-leave-to {
    animation: fadeOutDownBig 1s;
  }
  .line {
    height: 16px;
    width: 1px;
    @include bgColorOpacity(.16);
    margin-left: 8px;
    margin-right: 16px;
  }
  .el-dropdown .el-dropdown-link {
    @include fontColorOpacity(.6);
    font-size: 14px;
    font-weight: 400;
    i {
      @include fontColorOpacity(.6);
      font-weight: 400;
      margin-right: 9px;
    }
  }
  .filter-status {
    margin-left: 8px;
  }
  .el-dropdown-link {
    padding:8px;
  }
}
</style>
